import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { VendorGroup } from "../../definitions/vendor-group";
import { AppConfigService } from "../app.config.service";
import { ApiService } from "./api.service";
import { BaseApiService } from "./base-api.service";

@Injectable({ providedIn: "root" })
export class VendorGroupService extends BaseApiService {
	constructor(
		private api: ApiService,
		appConfigService: AppConfigService
	) {
		super("mpapi/vendor-groups", appConfigService.getConfigValue("API_ENDPOINT"));
	}

	getVendorGroups(): Observable<VendorGroup[]> {
		return this.api.get(this.url());
	}

	createVendorGroup(request: VendorGroup): Observable<VendorGroup> {
		return this.api.post(this.url(), request);
	}

	updateVendorGroup(request: VendorGroup): Observable<VendorGroup> {
		return this.api.put(this.url(`/${request.id}`), request);
	}
}
